import { useState } from 'react'
import { useNavigate, useRouter, useParams } from '@tanstack/react-router'
import { signOut } from '@/lib/auth-client'
import { clearAuthData } from '@/lib/auth'
import { Button } from '@deepguide-ai/ui/button'

export default function ForbiddenError() {
  const navigate = useNavigate()
  const { history } = useRouter()
  const { workspaceId } = useParams({ strict: false }) as { workspaceId?: string }
  const [signingOut, setSigningOut] = useState(false)

  const handleBackToHome = () => {
    if (workspaceId) {
      navigate({
        to: '/workspaces/$workspaceId/tasks',
        params: { workspaceId },
      })
    } else {
      navigate({ to: '/' })
    }
  }

  const handleSignOut = async () => {
    setSigningOut(true)
    try {
      await signOut()
      await clearAuthData()
    } catch {
      // Best-effort cleanup
    }
    navigate({ to: '/login' })
  }

  return (
    <div className='h-svh'>
      <div className='m-auto flex h-full w-full flex-col items-center justify-center gap-2'>
        <h1 className='text-[7rem] font-bold leading-tight'>403</h1>
        <span className='font-medium'>Access Forbidden</span>
        <p className='text-center text-muted-foreground'>
          You don't have necessary permission <br />
          to view this resource.
        </p>
        <div className='mt-6 flex gap-4'>
          <Button variant='outline' onClick={() => history.go(-1)}>
            Go Back
          </Button>
          <Button onClick={handleBackToHome}>Back to Home</Button>
          <Button variant='destructive' onClick={handleSignOut} disabled={signingOut}>
            {signingOut ? 'Signing out...' : 'Sign Out'}
          </Button>
        </div>
      </div>
    </div>
  )
}
